import { InjectionToken } from "@angular/core";

/** server node provide this token to inject nonce value */
export const CSP_NONCE_TOKEN = new InjectionToken<boolean>('CSP_NONCE_TOKEN');
